module.exports = __webpack_public_path__ + "img/cordoba_summer.035f8254.svg";